import useGoToNavigation from "../../../../util/useGotoNavigation";
import Dropdown from "react-bootstrap/Dropdown";
import EmptyTableRow from "../../../common/EmptyTableRow";
import {SalesRevenueViewInfoElementType} from "../list/interface";
import {useUpdateRevenueTableSetting} from "./hooks/useUpdateRevenueTableSetting";
import {useReadRevenueTableSetting} from "./hooks/useReadRevenueTableSetting";

export default function SalesColumn() {
    const {goToNavigation} = useGoToNavigation();

    const {data: column} = useReadRevenueTableSetting()
    const columnList: SalesRevenueViewInfoElementType[] = column?.revenueViewInfoVOList ?? []

    const {mutate: mutateUpdateRevenueTableSetting} = useUpdateRevenueTableSetting()


    const btnGoToList = () => {
        goToNavigation("main/sales/list", {}, false)
    }

    const btnHide = (el: SalesRevenueViewInfoElementType) => {
        const flag = el.isHidden === "Y" ? "N" : "Y"

        mutateUpdateRevenueTableSetting([{revenueViewInfoId: el.revenueViewInfoId, isHidden: flag}])
    }

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">컬럼 설정</h3>
            <div className="filter_toolbar">
                <button className="btn btn-outline-primary w-100px h-38px" onClick={btnGoToList}><img
                    src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>목록
                </button>
                {/* NOTE: 수정 버튼은 숨기기를 위한 버튼이고, 드롭다운 메뉴에서 숨길 수 있으므로 제거 */}
                {/*<button className="btn btn-secondary w-100px h-38px">수정</button>*/}
            </div>
        </div>
        <div className="table_top">
            <h6 className="table_stats">컬럼 목록(<span>{columnList.length}</span>건)</h6>
        </div>
        <table className="table table-bordered my_table">
            <thead>
            <tr>
                <th style={{width: "95%"}}>이름</th>
                <th style={{width: "5%"}}></th>
            </tr>
            </thead>
            <tbody>
            {columnList.length !== 0 ?
                columnList.map((el: SalesRevenueViewInfoElementType) => (<tr>
                    <td>{el.target}</td>
                    <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center">
                            {el.isHidden === "Y" &&
                                <button className="btn btn-default btn_td">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon-hide-eye.png"} alt=""/>
                                </button>
                            }
                            <Dropdown>
                                <Dropdown.Toggle className="dots_dropdown" variant="link">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon-dots.png"} alt=""/>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item
                                        onClick={() => btnHide(el)}>
                                        컬럼 {el.isHidden === "N" ? "숨기기" : "표시하기"}
                                    </Dropdown.Item>
                                    {/* NOTE: 삭제 없음 */}
                                    {/*<Dropdown.Item href="#/action-2">삭제하기</Dropdown.Item>*/}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </td>
                </tr>))
                : <EmptyTableRow colSpan={6}/>
            }
            </tbody>
        </table>
    </div>
}